import type { AxiosRequestConfig } from 'axios';
import type z from 'zod';
import { api } from '../../axios.instance';
import {
  PagePaginationResponseDtoSchema,
  responseContract,
  type PagePaginationRequestDto,
} from '../../lib';
import { StaffWageHistory } from '../contracts';

export const GetWageHistoryResponseDtoSchema =
  PagePaginationResponseDtoSchema(StaffWageHistory);

export type GetWageHistoryRequestDto = PagePaginationRequestDto<
  { id: number },
  'date' | 'madeBy' | 'reviewResult'
>;
export type GetWageHistoryResponseDto = z.infer<
  typeof GetWageHistoryResponseDtoSchema
>;

export const getWageHistory = async (
  params: GetWageHistoryRequestDto,
  config?: AxiosRequestConfig<GetWageHistoryRequestDto>
) => {
  const { id, ...restParams } = params;

  return await api
    .get(`staff/${id}/wage-history`, {
      params: restParams,
      ...config,
    })
    .then(responseContract(GetWageHistoryResponseDtoSchema));
};
